import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateFuelingServiceMetadata } from '../../api/fueling-service.ts';
import { UpdateFuelingServiceMetadataRequest } from '../../api/requests/fueling-service-request.ts';

export default function useUpdateFuelingServiceMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updateFuelingServiceMetadata>>,
  Error,
  UpdateFuelingServiceMetadataRequest
> {
  return useMutation({
    mutationFn: updateFuelingServiceMetadata,
  });
}
